<template>
  <div class="intv_cale" :style="cssVar">
    <div class="cale_title">
      <div class="title_left"></div>
      <div class="title_right">
        <div class="data_select">
          <el-date-picker
              v-model="dateValue"
              v-show="currentDateType==='date'"
              key="date"
              type="date"
              size="small"
              format="yyyy/MM/dd"
              popper-class="selectDate_box"
              :placeholder="getLangMsg('intvTaskCale_select_date')"
              value-format="yyyy/MM/dd"
              :clearable="false"
              :picker-options="{'firstDayOfWeek': 1}"
              @focus="changeColor"
          >
          </el-date-picker>
          <el-date-picker
              v-model="dateValue"
              v-show="currentDateType==='week'"
              key="week"
              type="week"
              size="small"
              :format="getLangMsg('intvTaskCale_yyyy_WW')"
              popper-class="selectDate_box"
              :placeholder="getLangMsg('intvTaskCale_select_week')"
              value-format="yyyy/MM/dd"
              :clearable="false"
              :picker-options="{'firstDayOfWeek': 1}"
              @focus="changeColor"
              @change="changeDate">
          </el-date-picker>
          <el-date-picker
              v-model="dateValue"
              v-show="currentDateType==='month'"
              key="month"
              type="month"
              size="small"
              format="yyyy-MM"
              popper-class="selectDate_box"
              :placeholder="getLangMsg('intvTaskCale_select_month')"
              value-format="yyyy/MM/dd"
              :clearable="false"
              :picker-options="{'firstDayOfWeek': 1}"
              @focus="changeColor"
          >
          </el-date-picker>
        </div>
        <div class="caleType_tab">
          <el-radio-group v-model="currentDateType" size="small">
            <el-radio-button label="date">{{getLangMsg("intvTaskCale_date")}}</el-radio-button>
            <el-radio-button label="week">{{getLangMsg("intvTaskCale_week")}}</el-radio-button>
            <el-radio-button label="month">{{getLangMsg("intvTaskCale_month")}}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="today_select">
<!--          <el-button size="small" @click="turnToToday">{{getLangMsg("intvTaskCale_today")}}</el-button>-->
          <div class="botton" @click="turnToToday">{{getLangMsg("intvTaskCale_today")}}</div>
        </div>
      </div>
    </div>
    <div class="cale_body">
      <el-carousel indicator-position="none" :initial-index="2" :autoplay="false" arrow="never" ref="carousel">
        <el-carousel-item key="date" name="date">
          <TaskDayView :class="{'invisible':currentDateType!='date'}" :dateValue="dateValue" :invoke="invoke" :dayData="dayData"
                       :currentDateType="currentDateType"></TaskDayView>
        </el-carousel-item>
        <el-carousel-item key="week" name="week">
          <TaskWeekView :class="{'invisible':currentDateType!='week'}" :dateValue="dateValue" :invoke="invoke" :weekData="weekData"
                        :currentDateType="currentDateType"></TaskWeekView>
        </el-carousel-item>
        <el-carousel-item key="month" name="month">
          <TaskMonthView :class="{'invisible':currentDateType!='month'}" :dateValue="dateValue" @setDateValue="setDateValue" :invoke="invoke"
                         :monthData="monthData" :currentDateType="currentDateType"></TaskMonthView>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import {utils} from '../common/common'
import TaskMonthView from './TaskMonthView.vue';
import TaskWeekView from './TaskWeekView.vue';
import TaskDayView from "./TaskDayView.vue";

export default {
  components: {
    TaskMonthView,
    TaskWeekView,
    TaskDayView,

  },
  props: {
    invoke: Function,
    dayData: Array,
    weekData: Array,
    monthData: Array,
    themeNum: String
  },
  watch: {
    currentDateType: function (val) {
      if (val) {
        this.$refs.carousel.setActiveItem(val)
      }
    }
  },
  computed: {
    cssVar() {
      return {
        '--color': this.themeNum,
        '--color-thin': utils.colorContrast[this.themeNum]
      }
    },
  },
  data() {
    return {
      newTodoText: '',
      currentDateType: 'month', //date\week\month
      dateValue: "",
    }
  },
  mounted() {
    this.dateValue = utils.dateFormat("yyyy/MM/dd")
  },
  methods: {
    changeDate(value) {
      if (this.currentDateType === 'week') {
        this.dateValue = utils.getNextDate(this.dateValue, -1);
      }
    },
    turnToToday() {
      this.dateValue = utils.dateFormat("yyyy/MM/dd")
    },
    setDateValue(dateStr) {
      this.dateValue = utils.dateFormat("yyyy/MM/dd", new Date(dateStr).getTime());
    },
    changeColor() {
      this.$nextTick(()=>{
        let eleS = $(".selectDate_box");
        for (let i = 0, len = eleS.length; i < len; i++) {
          eleS[i].style.setProperty('--color',this.themeNum);
          eleS[i].style.setProperty('--color-thin', utils.colorContrast[this.themeNum]);
        }
      })
    },
  }
}
</script>
<style lang="less">
.intv_cale {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100px;
  flex-direction: column;
  align-items: stretch;

  .cale_title {
    flex-shrink: 0;
    height: 54px;
    padding: 0 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px #C7CBD3;
    margin-bottom: 13px;

    .title_right {
      display: flex;
      flex-direction: row;

      .data_select .el-date-editor .el-input__inner {
        &:focus {
          border-color: #5582F3;
          border-color: var(--theme-color);
        }
      }

      .caleType_tab {
        margin-left: 10px;

        .el-radio-group {
          .is-active {
            .el-radio-button__inner {
              background-color: #5582F3;
              background-color: var(--theme-color);
              border-color: var(--theme-color);
              -webkit-box-shadow: -1px 0 0 0 #5582F3;
              -webkit-box-shadow: -1px 0 0 0 var(--theme-color);
              box-shadow: -1px 0 0 0 var(--theme-color);
              color: #FFFFFF !important;
            }
          }
        }

        .el-radio-button__inner {
          &:hover {
            color: #5582F3;
            color: var(--theme-color);
          }
        }
      }

      .today_select {
        margin-left: 10px;

        .botton {
          padding: 9px 15px;
          font-size: 12px;
          border-radius: 3px;
          display: inline-block;
          line-height: 1;
          white-space: nowrap;
          cursor: pointer;
          background: #FFF;
          border: 1px solid #DCDFE6;
          color: #606266;
          -webkit-appearance: none;
          text-align: center;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          outline: 0;
          margin: 0;
          -webkit-transition: 0.1s;
          transition: 0.1s;
          font-weight: 500;
          &:hover {
            color: #5582F3;
            color: var(--theme-color);
            border-color: var(--theme-color);
            background-color: #ffffff;
          }

        }
      }
    }
  }

  .cale_body {
    padding: 0 26px 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100px;
    flex-shrink: 1;
    flex-grow: 1;

    .el-carousel {
      height: 100%;

      .el-carousel__container {
        height: 100%;

        .el-carousel__item {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: stretch;
        }
      }
    }
    .invisible{
      visibility: hidden;
    }
  }

  .el-icon-date {
    font-family: kdfont !important;

    &::before {
      content: "\e648";
    }
  }

  .el-icon-circle-close {
    font-family: kdfont !important;

    &::before {
      content: "\ebdf";
    }
  }
}

.selectDate_box {
  .el-icon-d-arrow-left {
    font-family: kdfont !important;

    &::before {
      content: "\e710";
    }
  }

  .el-icon-arrow-left {
    font-family: kdfont !important;

    &::before {
      content: "\e89e";
    }
  }

  .el-icon-arrow-right {
    font-family: kdfont !important;

    &::before {
      content: "\e89d";
    }
  }

  .el-icon-d-arrow-right {
    font-family: kdfont !important;

    &::before {
      content: "\e704";
    }
  }

  .el-picker-panel__content {
    .el-date-table {
      .el-date-table__row {
        .available {
          &:hover {
            color: #5582F3;
            color: var(--theme-color);
          }
        }

        .today span {
          color: #5582F3;
          color: var(--theme-color);
        }

        .current span {
          color: #FFFFFF;
          background-color: #5582F3;
          background-color: var(--theme-color);
        }
      }
    }

    .is-week-mode {
      .el-date-table__row {
        &:hover > .available > div {
          background-color: var(--theme-color-level1);
        }
        &:hover > .next-month > div {
          background-color: var(--theme-color-level1);
        }

        .end-date, .start-date {
          span {
            background-color: #5582F3;
            background-color: var(--theme-color);
            color: #FFFFFF;
          }
        }
      }

      .current > .available > div {
        background-color: var(--theme-color-level1);
      }
      .current > .next-month > div {
        background-color: var(--theme-color-level1);
      }

    }

    .el-month-table, .el-year-table {
      .cell {
        &:hover {
          color: #5582F3;
          color: var(--theme-color);
        }
      }

      .current .cell {
        color: #5582F3;
        color: var(--theme-color);
      }

      .today .cell {
        color: #5582F3;
        color: var(--theme-color);
      }
    }
  }

  .el-date-picker__header {
    .el-picker-panel__icon-btn, .el-date-picker__header-label {
      &:hover {
        color: #5582F3;
        color: var(--theme-color);
      }
    }
  }

}
</style>